export default __webpack_public_path__ + "static/media/allowLocation.5708d2be.png";